/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateStandardEventMetricRequestBody = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
},
        isLeaderOrderDescending: {
    type: 'boolean',
    isRequired: true,
},
    },
};